<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
             <FormDynamicV2
                    :form_format="first_form_format"
                    :form_data="single_object"
                    :array_options="array_options"   
                    name="first_form"
                />
            <form class="col-12 p-0 mt-3 log-productivty-form" @submit.prevent="save()">
                <div class="shadow p-3 bg-white rounded mb-3">
                    <h2 class="view__title title--1" style="font-size: 18px">
                        <span v-html="'Census Information'"/>
                    </h2>
                    <FormDynamicV2
                        :form_format="second_form_format"
                        :form_data="single_object"
                        :array_options="array_options"   
                        name="second_form"
                    />
                    <div class="shadow-none p-2 pb-4 bg-light rounded border mb-3 log-productivty-form__third">
                        <FormDynamicV2 :form_format="third_form_format" :form_data="single_object"
                            :array_options="array_options" name="third_form" />
                    </div>
                    <center>
                    <h2 class="view__title title--1" style="font-size: 18px">
                        <span v-html="'Case Cleaning Information'"/>
                    </h2>         
                    </center>
                    <div class="row">
                        <div class="col-md-8">
                            <table class="table table-without-border">
                                <thead class="bg-white">
                                    <tr>
                                    <th scope="col" style="font-size: 15px !important"></th>
                                    <th scope="col" style="font-size: 15px !important">Number of cases</th>
                                    <th scope="col" style="font-size: 15px !important">Total Minutes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in fourth_form_format" :key="index" style="line-height: 0.5">
                                        <td v-html="item.name" class="modal-label p-0" style="font-size: 15px !important"/>
                                        <td v-for="(field,j) in item.fields" :key="j" class="p-1">
                                        <div>
                                            <input 
                                            :placeholder="field['placeholder'] !== undefined ? field.placeholder : ''"
                                            :disabled="field.disabled"
                                            :step="field.step"
                                            :type="field.type" 
                                            :maxlength="field.maxlength"
                                            style="max-width: 85%; border-bottom: 1px solid #9e9e9e8c !important;"
                                            :min="field.type === 'date' && min_date !== undefined ? min_date : field.minlength !== undefined ? field.minlength : ''"
                                            :max="field.type === 'date' && max_date !== undefined ? max_date : field.maxlength"
                                            :required="field.required"
                                            v-model="single_object[field.model_name]"
                                            />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row p-3">
                        <div class="p-0 formdynamic__item col-md-7" >
                            <div class="formdynamic__item__field">
            
                        <label v-html="'Comments:'" class="modal-label" for="notes"/>
                            <textarea
                                id="notes"
                                class="notes-text-area" 
                                maxlength="500"
                                v-model="single_object['notes']"
                                rows="5"
                            />
                            </div>
                        </div>
                    </div>
                </div>
                <LocalCentralButtons
                    :save_view="true"
                    :modal_name="'static'"
                    @saveView="save_and_view($event)"
                />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamicV2     from  '@/components/FormDynamicV2.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import LocalCentralButtons  from    '@/components/QcComponent/Inspection/LocalCentralButtons'
import { emitDischargesForDashboard } from '../../../plugins/socket'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamicV2,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
    },

    data(){
        return{
            first_form_format:  FormResources.first_form_format,
            second_form_format: FormResources.second_form_format,
            third_form_format:  FormResources.third_form_format,
            fourth_form_format:  FormResources.fourth_form_format,
            message: ''
        }
    },

    watch:{
        single_object:{
            handler(val){
                if(val.manually_generated == 0 || val.manually_generated == 3)
                {
                    this.first_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                field.disabled = true
                            })
                        }
                    })

                    this.second_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                if(val.allow_change_associate && field.model_name == 'associate_id')
                                {
                                    field.disabled = false
                                }
                                else
                                {
                                    if(field.model_name === 'include_productivity')
                                    {
                                        field.disabled = false
                                    }
                                    else
                                    {
                                        field.disabled = true
                                    }
                                }
                            })
                        }
                    })
                    
                    this.fourth_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                field.disabled = true
                            })
                        }
                    })

                    this.message = `The productivity log was automatically generated upon completing the assignment, ensuring that all data is accurately calculated and cannot be modified.`
                }
                else
                {
                    this.first_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                field.disabled = false
                            })
                        }
                    })

                    this.second_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                if(!field.calculated)
                                {
                                    field.disabled = false
                                }
                            })
                        }
                    })
                    
                    this.fourth_form_format.forEach(item => {
                        if(item.fields && item.fields.length)
                        {
                            item.fields.forEach(field => {
                                field.disabled = false
                            })
                        }
                    })

                    this.message = ``
                }
            },
            deep: true
        }
    },
    
    methods:
    {
        async save()
        {
            await this.form_submit_update(this.single_object.id, this.global_index)
            emitDischargesForDashboard(this.get_user().facility_id)
        },
        save_and_view(event) 
        {
            this.$emit('saveView', event)
        },
    },

    mounted(){

    }
    
}
</script>